import React from 'react';

const AdminVolunteers = () => {
    return (
        <div className="section-padding">
            <div className="container-custom">
                <h1 className="text-3xl font-bold mb-6">Manage Volunteers</h1>
                <p className="text-gray-600">Volunteer management interface coming soon.</p>
            </div>
        </div>
    );
};

export default AdminVolunteers;
